export const ACUITY_ASSETS_NAMES = {
  equity: 'Equity',
  index: 'Index',
  commodity: 'Commodity',
  currencyPairs: 'Currency Pairs',
  coins: 'Coins',
};

export const AcuitySignalsToPlatformAsset = {
  Cardano: 'ADAUSD',
  Ethereum: 'ETHUSD',
  Litecoin: 'LTCUSD',
  Polkadot: 'DOTUSD',
  Ripple: 'XRPUSD',
  Stellar: 'XLMUSD',
  Bitcoin: 'BTCUSD',
  Binance: 'BNBUSD',
  Dash: 'DSHUSD',
  Monero: 'XMRUSD',
  Namecoin: 'XEMUSD',
  'Germany 30': 'GER30',
  'SP 500': 'US500',
  'France 40': 'FRA40',
  'Japan 225': 'JAP225',
  'Italy 40': 'ITA40',
  'Spain 35': 'SPA35',
  'Hang-Seng': 'HKIND',
  'Hang Seng China Enterprises': 'CHNIND',
  'Euro Stoxx 50': 'EU50',
  'FTSE 100': 'UK100',
  Copper: 'COPPER',
  Sugar: 'SUGAR',
  Cotton: 'COTTON',
  Coffee: 'COFFEE',
  NatGas: 'NGAS',
  'WTI Crude Oil': 'WTI',
  ALUMINUM: 'MAL',
  Cocoa: 'COCOA',
  Wheat: 'WHEAT',
  NICKEL: 'NI',
  Corn: 'CORN',
  Palladium: 'XPDUSD',
  Platinum: 'XPTUSD',
  Silver: 'XAGUSD',
  Gold: 'XAUUSD',
};

export const INDEXES_DENY_LIST = [
  'GER30',
  'GER40',
  'US500',
  'FRA40',
  'JAP225',
  'ITA40',
  'SPA35',
  'EU50',
  'UK100',
  'ASX200',
  'HS50',
  'NIK225',
  'CHN50',
  'HKIND',
  'CHNIND',
  'COPPER',
  'COTTON',
  'COFFEE',
  'SUGAR',
  'NGAS',
  'WTI',
  'MAL',
  'COCOA',
  'WHEAT',
  'NI',
  'CORN',
];
